import React from 'react';
import {
  ExpoImage,
  Icon,
  LoadingIndicator,
  Pressable,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  Surface,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import * as Linking from 'expo-linking';
import { ActivityIndicator, Image, Modal, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import handleOpenURL from '../global-functions/handleOpenURL';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import openImagePickerUtil from '../utils/openImagePicker';
import useWindowDimensions from '../utils/useWindowDimensions';

const ProfileScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [isUploading, setIsUploading] = React.useState(false);
  const [selectedPhoto, setSelectedPhoto] = React.useState('');
  const [showLogoutModal, setShowLogoutModal] = React.useState(false);
  const leadFunlDefaultUpdateAgentProfilePicturePUT =
    LeadFunlDefaultApi.useUpdateAgentProfilePicturePUT();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      hasTopSafeArea={true}
    >
      {/* Container */}
      <View style={StyleSheet.applyWidth({ flex: 1 }, dimensions.width)}>
        {/* Header */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              flexDirection: 'row',
              height: 48,
              justifyContent: 'space-between',
              padding: 8,
            },
            dimensions.width
          )}
        >
          {/* Image 2 */}
          <ExpoImage
            allowDownscaling={true}
            cachePolicy={'disk'}
            contentPosition={'center'}
            transitionDuration={300}
            transitionEffect={'cross-dissolve'}
            transitionTiming={'ease-in-out'}
            {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
            resizeMode={'contain'}
            source={imageSource(Images['officedotlogo'])}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                {
                  height: [
                    { minWidth: Breakpoints.Mobile, value: 50 },
                    { minWidth: Breakpoints.Tablet, value: 65 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Tablet, value: 130 },
                    { minWidth: Breakpoints.Laptop, value: 140 },
                  ],
                }
              ),
              dimensions.width
            )}
          />
        </View>

        <LeadFunlDefaultApi.FetchAuthMeGET
          handlers={{
            onData: fetchData => {
              try {
                if (isUploading) {
                  return;
                }
                if (!isUploading) {
                  setSelectedPhoto(fetchData?.profile.url);
                }
              } catch (err) {
                console.error(err);
              }
            },
          }}
        >
          {({ loading, error, data, refetchAuthMe }) => {
            const fetchData = data?.json;
            if (loading) {
              return <ActivityIndicator />;
            }

            if (error || data?.status < 200 || data?.status >= 300) {
              return <ActivityIndicator />;
            }

            return (
              <SimpleStyleScrollView
                bounces={true}
                horizontal={false}
                keyboardShouldPersistTaps={'never'}
                nestedScrollEnabled={false}
                showsHorizontalScrollIndicator={true}
                showsVerticalScrollIndicator={true}
                style={StyleSheet.applyWidth(
                  { flex: 1, marginBottom: 20, paddingBottom: 25 },
                  dimensions.width
                )}
              >
                {/* User Details */}
                <View
                  style={StyleSheet.applyWidth(
                    { justifyContent: 'center', minHeight: 200 },
                    dimensions.width
                  )}
                >
                  {/* Photo */}
                  <View
                    style={StyleSheet.applyWidth(
                      { alignItems: 'center' },
                      dimensions.width
                    )}
                  >
                    {/* SelectedPhoto */}
                    <>
                      {!selectedPhoto ? null : (
                        <Image
                          resizeMode={'cover'}
                          source={imageSource(`${selectedPhoto}`)}
                          style={StyleSheet.applyWidth(
                            {
                              borderRadius: 60,
                              height: 110,
                              opacity: isUploading ? 20 : 100,
                              position: 'absolute',
                              top: 5,
                              width: 110,
                            },
                            dimensions.width
                          )}
                        />
                      )}
                    </>
                    <>
                      {selectedPhoto ? null : (
                        <Image
                          resizeMode={'cover'}
                          source={imageSource(Images['placeholderimage'])}
                          style={StyleSheet.applyWidth(
                            {
                              borderRadius: 60,
                              height: 110,
                              position: 'absolute',
                              top: 5,
                              width: 110,
                            },
                            dimensions.width
                          )}
                        />
                      )}
                    </>
                    <>
                      {!isUploading ? null : (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: 'center',
                              backgroundColor: 'rgba(0, 0, 0, 0)',
                              borderRadius: 60,
                              height: 110,
                              justifyContent: 'center',
                              paddingTop: 5,
                              position: 'absolute',
                              width: 110,
                            },
                            dimensions.width
                          )}
                        >
                          <LoadingIndicator
                            color={theme.colors.branding.primary}
                            size={30}
                            type={'circleFade'}
                          />
                        </View>
                      )}
                    </>
                    <Touchable
                      onPress={() => {
                        const handler = async () => {
                          try {
                            const res = await openImagePickerUtil({
                              mediaTypes: 'Images',
                              allowsEditing: false,
                              quality: 0.2,
                              allowsMultipleSelection: false,
                              selectionLimit: 0,
                              outputBase64: true,
                            });

                            if (res) {
                              setSelectedPhoto(res);
                            }
                            setIsUploading(true);
                            (
                              await leadFunlDefaultUpdateAgentProfilePicturePUT.mutateAsync(
                                { image_file: res }
                              )
                            )?.json;
                            setIsUploading(false);
                          } catch (err) {
                            console.error(err);
                          }
                        };
                        handler();
                      }}
                      activeOpacity={0.8}
                      disabledOpacity={0.8}
                    >
                      <Image
                        resizeMode={'cover'}
                        source={imageSource(Images['EditPicFrame'])}
                        style={StyleSheet.applyWidth(
                          { height: 137, width: 120 },
                          dimensions.width
                        )}
                      />
                    </Touchable>
                  </View>
                  {/* Name */}
                  <Text
                    accessible={true}
                    selectable={false}
                    style={StyleSheet.applyWidth(
                      {
                        color: theme.colors.text.strong,
                        fontFamily: 'Poppins_500Medium',
                        fontSize: 18,
                        lineHeight: 20,
                        marginTop: 12,
                        textAlign: 'center',
                        textTransform: 'capitalize',
                      },
                      dimensions.width
                    )}
                  >
                    {fetchData?.name}
                  </Text>
                  {/* ID */}
                  <Text
                    accessible={true}
                    selectable={false}
                    style={StyleSheet.applyWidth(
                      {
                        color: theme.colors.text.strong,
                        fontFamily: 'Poppins_400Regular',
                        fontSize: 12,
                        lineHeight: 14,
                        marginTop: 4,
                        opacity: 0.6,
                        textAlign: 'center',
                      },
                      dimensions.width
                    )}
                  >
                    {'Agent ID: #'}
                    {fetchData?.id}
                  </Text>
                </View>
                {/* Menu */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      backgroundColor: palettes.App['Custom #ffffff'],
                      borderRadius: 12,
                      padding: 8,
                      paddingTop: 25,
                    },
                    dimensions.width
                  )}
                >
                  {/* Dashboard */}
                  <Touchable
                    onPress={() => {
                      try {
                        navigation.navigate('DashboardScreen');
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    activeOpacity={0.3}
                  >
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                          { borderRadius: 6 }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: 60,
                            marginLeft: 12,
                          },
                          dimensions.width
                        )}
                      >
                        <Icon
                          size={24}
                          color={theme.colors.text.strong}
                          name={'MaterialCommunityIcons/monitor-dashboard'}
                          style={StyleSheet.applyWidth(
                            { opacity: 0.6 },
                            dimensions.width
                          )}
                        />
                        <Text
                          accessible={true}
                          selectable={false}
                          style={StyleSheet.applyWidth(
                            {
                              color: theme.colors.text.strong,
                              fontFamily: 'Poppins_500Medium',
                              fontSize: 15,
                              marginLeft: 10,
                              opacity: 0.8,
                            },
                            dimensions.width
                          )}
                        >
                          {'Dashboard'}
                        </Text>
                      </View>
                    </Surface>
                  </Touchable>
                  {/* Tutorials */}
                  <Touchable
                    onPress={() => {
                      try {
                        navigation.navigate('TutorialsScreen');
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    activeOpacity={0.3}
                    style={StyleSheet.applyWidth(
                      { marginTop: 4 },
                      dimensions.width
                    )}
                  >
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                          { borderRadius: 6 }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: 60,
                            marginLeft: 12,
                          },
                          dimensions.width
                        )}
                      >
                        <Icon
                          size={24}
                          color={theme.colors.text.strong}
                          name={'MaterialIcons/slideshow'}
                          style={StyleSheet.applyWidth(
                            { opacity: 0.6 },
                            dimensions.width
                          )}
                        />
                        <Text
                          accessible={true}
                          selectable={false}
                          style={StyleSheet.applyWidth(
                            {
                              color: theme.colors.text.strong,
                              fontFamily: 'Poppins_500Medium',
                              fontSize: 15,
                              marginLeft: 10,
                              opacity: 0.8,
                            },
                            dimensions.width
                          )}
                        >
                          {'Tutorials'}
                        </Text>
                      </View>
                    </Surface>
                  </Touchable>
                  {/* Logout */}
                  <Touchable
                    onPress={() => {
                      try {
                        setShowLogoutModal(true);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    activeOpacity={0.3}
                    style={StyleSheet.applyWidth(
                      { marginTop: 4 },
                      dimensions.width
                    )}
                  >
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                          { borderRadius: 6 }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: 60,
                            marginLeft: 12,
                          },
                          dimensions.width
                        )}
                      >
                        <Icon
                          size={24}
                          color={theme.colors.branding.primary}
                          name={'AntDesign/logout'}
                          style={StyleSheet.applyWidth(
                            { opacity: 0.6 },
                            dimensions.width
                          )}
                        />
                        <Text
                          accessible={true}
                          selectable={false}
                          style={StyleSheet.applyWidth(
                            {
                              color: theme.colors.branding.primary,
                              fontFamily: 'Poppins_500Medium',
                              fontSize: 15,
                              marginLeft: 10,
                              opacity: 0.8,
                            },
                            dimensions.width
                          )}
                        >
                          {'Logout'}
                        </Text>
                      </View>
                    </Surface>
                  </Touchable>
                </View>
              </SimpleStyleScrollView>
            );
          }}
        </LeadFunlDefaultApi.FetchAuthMeGET>
        {/* Footer */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 12,
            },
            dimensions.width
          )}
        >
          {/* Privacy */}
          <Touchable
            onPress={() => {
              try {
                Linking.openURL(`${Constants['PRIVACY_POLICY']}`);
              } catch (err) {
                console.error(err);
              }
            }}
            activeOpacity={0.3}
          >
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: 'center',
                  flexDirection: 'row',
                  height: 30,
                  marginLeft: 12,
                },
                dimensions.width
              )}
            >
              <Text
                accessible={true}
                selectable={false}
                style={StyleSheet.applyWidth(
                  {
                    color: theme.colors.branding.primary,
                    fontFamily: 'Poppins_400Regular',
                    fontSize: 13,
                    marginLeft: 6,
                    opacity: 0.8,
                  },
                  dimensions.width
                )}
              >
                {'Privacy Policy'}
              </Text>
            </View>
          </Touchable>
          {/* Copy right */}
          <LeadFunlDefaultApi.FetchGetCopyrightDataGET>
            {({ loading, error, data, refetchGetCopyrightData }) => {
              const copyRightData = data?.json;
              if (loading) {
                return <ActivityIndicator />;
              }

              if (error || data?.status < 200 || data?.status >= 300) {
                return <ActivityIndicator />;
              }

              return (
                <SimpleStyleFlatList
                  data={copyRightData?.filter((_, index) => index === 0)}
                  decelerationRate={'normal'}
                  horizontal={false}
                  inverted={false}
                  keyExtractor={(listData, index) =>
                    listData?.id ??
                    listData?.uuid ??
                    index?.toString() ??
                    JSON.stringify(listData)
                  }
                  keyboardShouldPersistTaps={'never'}
                  listKey={'Container->Footer->Copy right->List'}
                  nestedScrollEnabled={false}
                  numColumns={1}
                  onEndReachedThreshold={0.5}
                  pagingEnabled={false}
                  renderItem={({ item, index }) => {
                    const listData = item;
                    return (
                      <>
                        {/* Footer */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: 'center',
                              height: 30,
                              justifyContent: 'center',
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Text'].props}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.TextStyles(theme)['Text'].style,
                                {
                                  color: theme.colors.text.medium,
                                  fontSize: 12,
                                  opacity: 0.7,
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            {listData?.copyright_text}
                          </Text>
                        </View>
                      </>
                    );
                  }}
                  showsHorizontalScrollIndicator={true}
                  showsVerticalScrollIndicator={true}
                  snapToAlignment={'start'}
                />
              );
            }}
          </LeadFunlDefaultApi.FetchGetCopyrightDataGET>
        </View>
      </View>
      {/* Modal - Logout */}
      <Modal
        supportedOrientations={['portrait', 'landscape']}
        animationType={'none'}
        transparent={true}
        visible={Boolean(showLogoutModal)}
      >
        <BlurView
          experimentalBlurMethod={'none'}
          intensity={50}
          tint={'default'}
          {...GlobalStyles.BlurViewStyles(theme)['Blur View'].props}
          style={StyleSheet.applyWidth(
            StyleSheet.compose(
              GlobalStyles.BlurViewStyles(theme)['Blur View'].style,
              { alignItems: 'center', justifyContent: 'center' }
            ),
            dimensions.width
          )}
        >
          <Surface
            {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
            elevation={3}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                {
                  borderColor: theme.colors.text.light,
                  borderRadius: 6,
                  borderTopWidth: 1,
                }
              ),
              dimensions.width
            )}
          >
            <View
              style={StyleSheet.applyWidth(
                {
                  backgroundColor: palettes.App.White,
                  borderRadius: 8,
                  overflow: 'hidden',
                  width: 300,
                },
                dimensions.width
              )}
            >
              {/* Title */}
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      fontFamily: 'Poppins_500Medium',
                      fontSize: 18,
                      marginTop: 12,
                      textAlign: 'center',
                    }
                  ),
                  dimensions.width
                )}
              >
                {'Logout?'}
              </Text>
              {/* message */}
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: theme.colors.text.medium,
                      paddingBottom: 12,
                      paddingTop: 12,
                      textAlign: 'center',
                    }
                  ),
                  dimensions.width
                )}
              >
                {'Are you sure you want to log out?'}
              </Text>
              {/* CTA */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: 'center',
                    borderColor: theme.colors.text.light,
                    borderTopWidth: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: 6,
                  },
                  dimensions.width
                )}
              >
                {/* Cancel */}
                <Pressable
                  onPress={() => {
                    try {
                      setShowLogoutModal(false);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  activeOpacity={0.3}
                  style={StyleSheet.applyWidth(
                    { width: '50%' },
                    dimensions.width
                  )}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        height: 48,
                        justifyContent: 'center',
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          { fontSize: 15 }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Cancel'}
                    </Text>
                  </View>
                </Pressable>
                {/* Logout */}
                <Pressable
                  onPress={() => {
                    try {
                      setShowLogoutModal(false);
                      setGlobalVariableValue({
                        key: 'AUTH_TOKEN',
                        value: '',
                      });
                      setGlobalVariableValue({
                        key: 'AUTH_USER',
                        value: {},
                      });
                      if (navigation.canGoBack()) {
                        navigation.popToTop();
                      }
                      navigation.replace('LoginScreen');
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  activeOpacity={0.3}
                  style={StyleSheet.applyWidth(
                    { width: '50%' },
                    dimensions.width
                  )}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        borderColor: theme.colors.text.light,
                        borderLeftWidth: 1,
                        height: 48,
                        justifyContent: 'center',
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: palettes.Brand.Error,
                            fontFamily: 'Poppins_500Medium',
                            fontSize: 15,
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Logout'}
                    </Text>
                  </View>
                </Pressable>
              </View>
            </View>
          </Surface>
        </BlurView>
      </Modal>
    </ScreenContainer>
  );
};

export default withTheme(ProfileScreen);
